<template>
  <div class="parent-rewards-main-container d-flex flex-column position-relative">
    <nav-title v-if="isOnParent" :color="true" :title="'Rewards'" custom-class="nav__title" />
    <button-print-screen v-if="isOnParent && this.childrenList && this.childrenList.length" />
    <reward-float-button :optionMe="showParentRewards"
      v-if="isOnParent && this.childrenList && this.childrenList.length"
      class="reward-float-position"
      @onCreate="
        () => {
          rewardDataToEdit = null;
          $refs.modals.openModal();
        }
      "
      @onSeeIdeas="() => $router.push({ name: 'RewardsIdeas' })"
    />
    <custom-spinner v-if="showSpinner" />
    <div
      v-if="isOnParent"
      class="d-flex justify-content-center reward-header-container border-bottom mt-3 position-relative"
    >
      <div
        class="reward-header-title reward-icon d-flex mr-auto ml-3 align-items-center position-absolute"
      >
        <span class="material-icons align-middle smaller">
          card_giftcard
        </span>
        <small class="text-uppercase font-weight-bold mx-1">
          Rewards
        </small>
        <question-popup
          popover-key="rewards"
          variant="primary"
          :title="popupInfo['reward']['title']"
          :description="popupInfo['reward']['information']"
        />
        <slot name="nav-subtitle-extra-title"></slot>
      </div>
      <div class=" grid-area-column-2 d-flex mt-5 mt-sm-0">
        <button
          class="parent-rewards-tab-button border-0 rounded-top p-2"
          :class="showParentRewards && 'reward-selected-button text-white'"
          @click="(showParentRewards = true), (showChildsRewards = false)"
        >
          Me
        </button>
        <button
          class="parent-rewards-tab-button border-0 rounded-top p-2"
          :class="showChildsRewards && 'reward-selected-button text-white'"
          @click="(showChildsRewards = true), (showParentRewards = false)"
        >
          My child
        </button>
      </div>
      <div
        class="reward-header-select grid-area-column-3 d-flex ml-auto mr-3 align-items-center position-absolute"
      >
        <radio-select
          v-if="showChildsRewards"
          :data="childrenList"
          :selectedValue="childSelected"
          @change="(...args) => setChildValue(...args)"
        />
      </div>
    </div>

    <stars-bar
      class="stars-bar"
      :data="getStarsData"
      :showParentStar="!showParentRewards"
    ></stars-bar>

    <b-alert
      :show="visibleAlertDuplicate"
      :variant="variantAlertDuplicate"
      dismissible
      @dismissed="visibleAlertDuplicate = 0"
      @dismiss-count-down="visibleAlertDuplicate = $event"
      >{{ messageAlertDuplicate }}</b-alert
    >

    <div v-if="showParentRewards" class="d-flex flex-column overflow-auto scrollable-container">
      <parent-reward
        :claimReward="claimParentReward"
        :parentRewardsList="parentRewards"
        :availableStars="parentAvailablePoints"
        :editReward="editParentReward"
        :deleteReward="opentDeleteParentReward"
      ></parent-reward>
    </div>
    <div
      v-if="showChildsRewards"
      class="d-flex flex-column"
      :class="{ 'scroll-childs-rewards': isOnParent }"
    >
      <section class="py-2 px-4 border-bottom" v-if="isOnParent">
        <reward-duplicate-controls
          :duplicatePopup="popupInfo['duplicate_reward']"
          :childSelected="childSelected"
          :childrens="childrenList"
          @on-duplicate="onDuplicate"
        ></reward-duplicate-controls>
      </section>
      <parent-children-rewards
        v-if="(childrenList && childrenList.length && isOnParent) || !isOnParent"
        :claimReward="claimReward"
        :todayRewardsList="todayRewardsList"
        :otherRewardsList="otherRewardsList"
        :availableStars="availableStars"
        :editReward="editChildReward"
        :deleteReward="openDeleteChildReward"
        :currentChild="currentChild"
        :totalStarsToday="getPossibleStarsToday"
        :starsEarned="todayStars"
        :dailyPopup="popupInfo['daily']"
        :rewardsToDuplicate.sync="rewardsToDuplicate"
      ></parent-children-rewards>
      <empty-module
        v-else
        title="No child have been added yet"
        :icon="'face'"
        :goFunction="() => $router.push('/register-child')"
        :customClass="'w-100'"
      />
    </div>
    <div v-if="isOnParent" class="d-flex justify-content-start justify-content-md-center" :class="{'button-next-rate' : showChildsRewards, 'my-5': !showChildsRewards}">
      <b-button variant="warning" class="px-5" @click="$router.push({ name: 'PlanMain' })">
        Next: Rate Parent Goals
      </b-button>
    </div>
    <!-- Modals -->
    <modal ref="modals" :title="rewardDataToEdit ? 'Edit reward' : 'New Reward'">
      <div class="p-4">
        <create-reward
          :createChild="!showParentRewards"
          :selectedChild="childSelected"
          :rewardData="rewardDataToEdit"
          :beforeSend="
            () => {
              showSpinner = true;
            }
          "
          :afterSend="() => afterSendData()"
        />
      </div>
    </modal>
    <modal ref="deletemodal" :title="'Delete reward'">
      <div class="p-4">
        <span class="">
          You are about to delete the
          <span class="font-weight-bold">{{ rewardDataToEdit ? rewardDataToEdit.name : '' }}</span>
          reward.
        </span>
        <b-col cols="12" class="mt-3">
          <b-button
            class="m-0 w-100"
            type="submit"
            variant="danger"
            block
            @click="
              () => {
                deleteChildRewardValidated();
              }
            "
          >
            Yes, delete
          </b-button>
        </b-col>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import store from '@/store';
import { validateEmptyArrays, createArrayDescriptor } from '@/utils/validateEmptyArrays.js';
import { ButtonPrintScreen } from '@/components/general/buttons';
import CustomSpinner from '@/components/general/customSpinner/customSpinner.vue';
import EmptyModule from '@/components/general/emptyModule.vue';
import Modal from '@/components/general/modal/modal.vue';
import NavTitle from '@/components/general/navTitle.vue';
import RadioSelect from '@/components/general/radioSelect/radioSelect.vue';
import QuestionPopup from '@/components/general/QuestionPopup.vue';
import StarsBar from '@/components/general/starsBar/starsBar.vue';
import CreateReward from '@/components/rewards/parent/createReward.vue';
import parentChildrenRewards from '@/components/rewards/parent/parentChildrenRewards.vue';
import parentReward from '@/components/rewards/parent/parentReward.vue';
import RewardDuplicateControls from '@/components/rewards/parent/RewardDuplicateControls.vue';
import RewardFloatButton from '@/components/rewards/RewardsFloatingButton.vue';

export default {
  name: 'rewards',
  props: {},
  components: {
    parentReward,
    parentChildrenRewards,
    RewardFloatButton,
    Modal,
    RadioSelect,
    CreateReward,
    CustomSpinner,
    StarsBar,
    EmptyModule,
    RewardDuplicateControls,
    QuestionPopup,
    ButtonPrintScreen,
    NavTitle,
  },
  data() {
    return {
      showSpinner: false,
      userId: store.getters['user/getUserId'],
      childSelected: 0,

      rewardDataToEdit: null,
      showParentRewards: false,
      showChildsRewards: true,
      childrenList: [],
      todayRewardsList: [],
      otherRewardsList: [],
      availableStars: 0,
      totalStars: 0,
      todayStars: 0,

      parentAvailablePoints: 0,
      parentTotalPoints: 0,
      parentRewards: [],

      isOnParent: false,

      availableToday: 0,
      popupInfo: {
        reward: {},
        daily: {},
        duplicate_reward: {},
      },

      rewardsToDuplicate: [],
      variantAlertDuplicate: undefined,
      messageAlertDuplicate: '',
      visibleAlertDuplicate: 0,
    };
  },
  methods: {
    ...mapMutations('rewards', ['setIsDuplicateActivate']),
    ...mapActions('parent', ['FetchChildrenData']),
    ...mapActions('rewards', [
      'FetchChildRewards',
      'DeleteReward',
      'DeleteParentReward',
      'FetchParentRewards',
      'FetchParentPoints',
      'ClaimParentRewards',
      'ClaimRewards',
    ]),
    ...mapActions('challenge', ['FetchChildCriterionValuesToday']),
    claimParentReward(rewardId) {
      this.ClaimParentRewards(rewardId).then(() => {
        this.loadParentData();
      });
    },
    claimReward(rewardId, name, image) {
      this.ClaimRewards(rewardId).then(() => {
        this.loadChildrenData();
        this.$root.$emit('showRewardClaimedCongrats', name, image);
      });
    },
    setChildValue(value) {
      this.childSelected = value;
      localStorage.setItem('rewardChildId', this.childSelected);
      this.loadChildrenData();
    },
    editChildReward(reward) {
      this.rewardDataToEdit = reward;
      this.$refs.modals.openModal();
    },
    openDeleteChildReward(reward) {
      this.rewardDataToEdit = reward;
      this.$refs.deletemodal.openModal();
    },
    editParentReward(reward) {
      this.rewardDataToEdit = reward;
      this.$refs.modals.openModal();
    },
    opentDeleteParentReward(reward) {
      this.rewardDataToEdit = reward;
      this.$refs.deletemodal.openModal();
    },
    deleteChildRewardValidated() {
      if (!this.showParentRewards) {
        this.DeleteReward(this.rewardDataToEdit.id).then(() => {
          this.loadChildrenData();
          this.$refs.deletemodal.closeModal();
        });
      } else {
        this.DeleteParentReward(this.rewardDataToEdit.id).then(() => {
          this.loadParentData();
          this.$refs.deletemodal.closeModal();
        });
      }
    },
    afterSendData() {
      this.$refs.modals.closeModal();
      if (!this.showParentRewards) {
        this.loadChildrenData();
      } else {
        this.loadParentData();
      }
    },
    getRewardsStars(rewardInfo = {}) {
      const mockStars = {
        available_stars: 0,
        today_stars: 0,
        available_today: 0,
        total_stars: 0,
      };
      const hasRewards = Boolean(Object.keys(rewardInfo).length);
      const stars = hasRewards ? { ...mockStars, ...rewardInfo } : mockStars;
      return stars;
    },
    loadChildrenData() {
      this.showSpinner = true;
      this.FetchChildRewards(this.childSelected)
        .then(() => {
          const selectedChildReward = this.getChildSelectedRewards(this.childSelected);
          const {
            available_stars,
            today_stars,
            available_today,
            total_stars,
          } = this.getRewardsStars(selectedChildReward);

          this.availableStars = available_stars;
          this.todayStars = today_stars;
          this.totalStars = total_stars;
          this.availableToday = available_today;

          this.todayRewardsList = [
            ...selectedChildReward.available_rewards,
            ...selectedChildReward.claimed_rewards,
            ...selectedChildReward.unavailable_rewards,
          ].filter((reward) => reward.reward_type != 'long_term');
          this.otherRewardsList = [
            ...selectedChildReward.available_rewards,
            ...selectedChildReward.claimed_rewards,
            ...selectedChildReward.unavailable_rewards,
          ].filter((reward) => reward.reward_type == 'long_term');
        })
        .then(() => this.FetchChildCriterionValuesToday(this.childSelected))
        .finally(() => (this.showSpinner = false));
    },
    loadParentData() {
      if (this.userIsAParent) {
        this.showSpinner = true;
        this.FetchParentRewards(this.userId).then(() => {
          const parentRewardsData = this.getParentRewards(this.userId);
          this.parentRewards = [
            ...parentRewardsData.available_rewards,
            ...parentRewardsData.claimed_rewards,
            ...parentRewardsData.unavailable_rewards,
          ];
          this.parentAvailablePoints = parentRewardsData.available_points;
          this.parentTotalPoints = parentRewardsData.total_points;
          this.showSpinner = false;
        });
      }
    },
    activeTemporalAlert(message, variant, timeInSeconds = 5) {
      this.messageAlertDuplicate = message;
      this.variantAlertDuplicate = variant;
      this.visibleAlertDuplicate = timeInSeconds;
    },
    generateDataToDuplicate(tarjetChildren) {
      return tarjetChildren.map((childId) => ({
        to_child_id: childId,
        from_child_id: this.childSelected,
        selected_rewards_ids: this.rewardsToDuplicate,
      }));
    },
    async getPopupsInfo() {
      try {
        const { data } = await axios.get('/pop/reward_pop');
        this.popupInfo = { ...data };
      } catch (error) {
        console.log('[UI] Error to trying get the popup info');
      }
    },
    async onDuplicate({ childrenIds, closeDuplicate }) {
      try {
        validateEmptyArrays([
          createArrayDescriptor(childrenIds, 'child'),
          createArrayDescriptor(this.rewardsToDuplicate, 'reward'),
        ]);

        this.showSpinner = true;
        const data = this.generateDataToDuplicate(childrenIds);
        closeDuplicate();

        await axios.post('child_reward/duplicate_reward/', data);
        this.activeTemporalAlert('Reward duplication was successful!', 'success');
        this.loadChildrenData();
      } catch (error) {
        const message = ['EmptyArray'].includes(error.name)
          ? error.message
          : 'Duplication was unsuccessful, try again';

        this.activeTemporalAlert(message, 'danger');
      } finally {
        this.showSpinner = false;
      }
    },
  },
  computed: {
    ...mapGetters('parent', ['getChildrenData']),
    ...mapGetters('user', ['userIsAParent', 'getUserId', 'getChildrenIds', 'getChildSelectedId']),
    ...mapGetters('rewards', ['getChildSelectedRewards', 'getParentRewards', 'getParentPoints']),
    ...mapGetters('challenge', ['getPossibleStarsToday']),
    currentChild() {
      return this.childrenList.find((child) => child.value === this.childSelected);
    },
    getStarsData() {
      const ShowReward = this.showParentRewards;
      return [
        {
          text: ShowReward ? 'Available points' : `Daily Reward Stars`,
          stars: ShowReward ? this.parentAvailablePoints : this.availableToday,
          display: true,
        },
        { text: 'Big Reward Stars', stars: this.availableStars, display: !ShowReward },
        {
          text: ShowReward ? 'Total points' : `Grand Total`,
          stars: ShowReward ? this.parentTotalPoints : this.totalStars,
          display: true,
        },
      ];
    },
  },
  async mounted() {
    // to display header if is on parent page
    this.isOnParent = this.userIsAParent;

    // get children list from store
    this.childrenList = this.getChildrenData
      .filter((child) => child.child_enabled)
      .map((child) => {
        return {
          value: child.id,
          text: child.name,
          image: child.avatar && child.avatar.image ? child.avatar.image : null,
        };
      });
    // set selected child
    this.childSelected = this.childrenList.length > 0 ? this.childrenList[0].value : 0;
    if (this.userIsAParent) {
      // load last selected child
      const childrenIdList = this.childrenList ? this.childrenList.map((c) => c.value) : [];
      const localChildId = Number(localStorage.getItem('rewardChildId'));
      if (localChildId && childrenIdList.includes(localChildId)) {
        this.childSelected = localChildId;
      }

      if (this.childrenList && this.childrenList.length) {
        // load children rewards
        this.loadChildrenData();
      }
    } else {
      this.childSelected = this.userId;
      this.loadChildrenData();
    }

    this.loadParentData();
    await this.getPopupsInfo();
  },
  beforeDestroy() {
    this.setIsDuplicateActivate(false);
  },
  beforeRouteEnter(to, from, next) {
    if (store.getters['user/userIsAParent']) {
      let userId = store.getters['user/getUserId'];

      Promise.all([store.dispatch('parent/FetchChildrenData', userId)]).then(next);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss">
.parent-rewards-main-container {
  .parent-rewards-custom-subtitle {
    border: none !important;
  }
  .nav__title {
    section {
      gap: 1rem;
      text-align: left !important;
    }
  }
}
.print-screen {
  bottom: 13px;
  @media (min-width: 568px) {
    bottom: 25px;
    right: 16.5rem;
  }
}
.child-reward-title {
  color: #1e90ff;
  font-size: 1.2rem;
}

.reward-header-container {
  width: 100%;

  .reward-header-title {
    top: 0;
    left: 0;
    height: 45px;

    .wrapper-question-popover {
      font-size: 16px;
    }
  }
  .reward-header-select {
    top: 0;
    right: 0;
    height: 45px;
  }
}

.parent-rewards-main-container {
  .parent-rewards-tab-button {
    font-size: 1rem;
    width: 6.25rem;
    outline: none;
    color: #1e90ff;
    background-color: transparent;
  }
  .reward-selected-button {
    background-color: #1e90ff;
  }
}
.icon-star-small {
  width: 1em;
  height: 1em;
}

.button-next-rate{
  
  @media (max-width:576px) {
    position: relative;
    top: -66px;
  }
}

.scroll-childs-rewards{
  overflow: inherit;
  padding-bottom: 75px;
  @media (min-width: 576px) {
    overflow: auto;
    padding: 0;
  }
}

.reward-icon {
  color: var(--color-main);
}

.stars-bar {
  padding: 0 15px;
}

.reward-float-position {
  @media screen and (max-width: 480px) {
    bottom: 3.7rem !important;
  }
}
</style>
